/** @jsx jsx */
/* istanbul ignore file */
import { jsx } from 'theme-ui';
import {
  Box,
  Text,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
  Tooltip,
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Flex,
} from '@chakra-ui/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { Fragment, useState } from 'react';
import {
  IoIosArrowDown,
  IoIosArrowUp,
  IoIosStar,
  IoMdCalendar,
  IoMdCheckboxOutline,
  IoMdRemoveCircleOutline,
  IoMdMore,
  IoIosArrowForward,
  IoMdAlarm,
  IoIosCalendar,
} from 'react-icons/io';
import { BsPersonCheckFill } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import _isNil from 'lodash/isNil';
import _includes from 'lodash/includes';
import { RiCloseCircleLine, RiErrorWarningLine } from 'react-icons/ri';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { HiOutlineRefresh } from 'react-icons/hi';
import { MdOutlineCheckCircle } from 'react-icons/md';
import { menuButtonCSS, menuListCSS } from '../SeekerHeader.styles';
import colors from '../../../../../styles/colors';
import { useSeekerContainerContext } from '../../SeekerContainerContext';
import {
  doesCandidateHasActiveAppointment,
  isCandidateAlreadyDismissed,
  isCandidateAlreadyHired,
  isCandidateReadOnly,
  isCandidateFromFollowedOrWatchedPosition,
  isCandidateHireInReview,
  isCandidateBlacklisted,
} from '../../../../../services/CandidateService';
import { MeetConfirmationModal } from './MeetConfirmationModal';
import { HireConfirmationModal } from './HireConfirmationModal';
import { UnhireConfirmationModal } from './UnhireConfirmationModal';
import { DismissConfirmationModal } from './DismissConfirmationModal';
import { SubscribeForBackgroundCheckModal } from './SubscribeForBackgroundCheckModal';
import { BackgroundCheckModal } from './BackgroundCheckModal';
import { CandidateStatus } from '../../../../../firebase/firestore/documents/candidate';
import { usePositionBackgroundCheckSnapshot } from './usePositionBackgroundCheckSnapshot';
import { MessageAfterHiringModal } from './MessageAfterHiringModal';
import { useSeekersFilters } from '../../../sidebar/filters/SeekersFiltersContext';
import { useCurrentUserProfile } from '../../../../../app/hooks/useCurrentUserProfile';
import { UnDismissConfirmationModal } from './UnDismissConfirmationModal';
import { HireRejectConfirmationModal } from './HireRejectConfirmationModal';
import { useStoreState } from '../../../../../models/hooks';
import { HireWithRequisitionModal } from './HireWithRequisitionModal';
import { useMessagingViewContext } from '../../../MessagingViewContext';
import { OfferMadePositionsView } from './OfferMadePositionsView';
import { AdHocInterviewModal } from './AdHocInterviewModal';
import { I9CheckModal } from './I9CheckModal';
import usePosition from '../../../sidebar/seekerList/usePosition';
import { useUserPermission } from '../../../../../services/permission/useUserPermission';
import { EmployeePermissionsEnum } from '../../../../administration/team/teamPermission/teamPermission.constant';
import { HireRejectCandidateModal } from './HireRejectCandidateModal';
import { HireFormReviewStatus } from './HireFormTypeEnum';
import PermissionWrapper from '../../../../../services/permission/PermissionWrapper';
import { PERMISSION_MODE } from '../../../../../services/permission/permission.interface';
import { isAdministrationAccount, isSuperAdministrationAccount } from '../../../../../services/userService';
import { CustomMenuItem } from '../../../../../app/components/CustomMenuItem';
import { UnblockConfirmModal } from './UnblockConfirmModal';
import { useSingleSeeker } from '../../../../../app/hooks/useSingleSeeker';
import { isBlacklistedBySeeker } from '../../../../../utils/candidatesUtils';

export type ActionsDropdownProps = {
  isCertnFeatureEnabled: boolean;
  isCertnEnabled: boolean;
  certnStatus?: string;
  isUserDeactivated?: boolean;
  isUndismissedeEnabled: boolean;
  isMessagingView: boolean;
};

export const ActionsDropdown = ({
  isCertnFeatureEnabled,
  isCertnEnabled,
  certnStatus,
  isUserDeactivated,
  isUndismissedeEnabled,
  isMessagingView,
}: ActionsDropdownProps): JSX.Element => {
  const { t } = useTranslation('messaging');
  const cancelRef = React.useRef(null);
  const { selectedCandidate } = useSeekerContainerContext();

  const {
    isHireModalOpen,
    onHireModalOpen,
    onHireModalClose,
    req,
    isMeetModalOpen,
    onMeetModalOpen,
    onConfirmModalClose,
    isAdhocInterviewOpen,
    onAdhocInterviewOpen,
    onAdhocInterviewModalClose,
    selectedSeeker,
    selectedEngagedCandidate,
    onHireDetailModalOpen,
    setCurrentHireFormReviewStatus,
  } = useMessagingViewContext();

  const candidate = selectedCandidate || selectedEngagedCandidate;

  const [isInterviewMenuExpand, setIsInterviewMenuExpand] = useState<boolean>(true);
  const [isHireMenuExpand, setIsHireMenuExpand] = useState<boolean>(true);

  const positionScreeningOption = usePositionBackgroundCheckSnapshot(candidate?.position);
  const { warningMessage } = useSeekersFilters();
  const { currentUserProfile } = useCurrentUserProfile();
  const position = usePosition(candidate?.newHireData?.positionId || candidate?.position);
  const seekerData = useSingleSeeker(candidate?.seeker);

  const { isOpen: isDismissModalOpen, onOpen: onDismissModalOpen, onClose: onDismissModalClose } = useDisclosure();
  const { isOpen: isHireRejectModalOpen, onOpen: onHireRejectModalOpen, onClose: onHireRejectModalClose } = useDisclosure();

  const { isOpen: isUnhireModalOpen, onOpen: onUnhireModalOpen, onClose: onUnhireModalClose } = useDisclosure();
  const { isOpen: isOpenWarning, onOpen: onOpenWarning, onClose: onCloseWarning } = useDisclosure();

  const { isOpen: isOpenHireCandidate, onOpen: onOpenHireCandidate, onClose: onCloseHireCandidate } = useDisclosure();
  const { isOpen: isI9CheckModalOpen, onOpen: onI9CheckModalOpen, onClose: onI9CheckModalClose } = useDisclosure();
  const {
    isOpen: isSubscribeForBackgroundCheckModalOpen,
    onOpen: onSubscribeForBackgroundCheckModalOpen,
    onClose: onSubscribeForBackgroundCheckModalClose,
  } = useDisclosure();
  const {
    isOpen: isBackgroundCheckModalOpen,
    onOpen: onBackgroundCheckModalOpen,
    onClose: onBackgroundCheckModalClose,
  } = useDisclosure();

  const { isOpen: isUnblockModalOpen, onOpen: onUnblockModalOpen, onClose: onUnblockModalClose } = useDisclosure();

  /* istanbul ignore next */
  const requisitionEnabled = useStoreState((state) => state.app.accounts?.configuration?.requisitionEnabled);
  /* istanbul ignore next */
  const adhocInterviewEnabled = useStoreState((state) => state.app.accounts?.configuration?.adhocInterviewEnabled);
  /* istanbul ignore next */
  const candidateReofferEnabled = useStoreState((state) => state.app.accounts?.configuration?.candidateReofferEnabled);
  const isAccountAutomaticHireDisabled = useStoreState((s) => s.app.accounts?.configuration?.automaticHireDisabled);
  const isPositionAutomaticHireDisabled = position?.automaticHireDisabled;
  const isAutomaticHireDisabledBothInAccountAndPosition = isAccountAutomaticHireDisabled && isPositionAutomaticHireDisabled;

  const superOwners = useStoreState((s) => s.app.accounts?.superOwners);
  const appUserId = useStoreState((s) => s.app.user?.id);
  const appOwnersId = useStoreState((s) => s.app.accounts?.owners);

  const isSuperAdmin = isSuperAdministrationAccount(superOwners, appUserId);
  const isAdmin = isAdministrationAccount(appOwnersId, appUserId);

  const hireFormEnabled = useStoreState((state) => state.app.accounts?.configuration?.hireFormEnabled);
  const hireFormEnabledPositions = useStoreState((s) => s.app.accounts?.configuration?.hireFormEnabledPositions);
  const workbrightEnabled = useStoreState((state) => state.app.accounts?.configuration?.workbright?.enabled);
  const isHrReviewUiEnabled = useStoreState((s) => s.app.accounts?.configuration?.hrReviewUiEnabled);

  const isCurrentCandiateNeitherFollowedNorWatched = candidate
    ? !isCandidateFromFollowedOrWatchedPosition(candidate, currentUserProfile?.id)
    : false;

  const {
    isOpen: isMessageAferHiringModalOpen,
    onOpen: onMessageAferHiringModalOpen,
    onClose: onMessageAferHiringModalClose,
  } = useDisclosure();

  const hireActionDisabled = candidate
    ? isCandidateAlreadyHired(candidate) ||
      isCandidateAlreadyDismissed(candidate) ||
      isCandidateReadOnly(candidate) ||
      isCandidateHireInReview(candidate.computedStatus?.status)
    : true;
  const meetActionDisabled = candidate
    ? doesCandidateHasActiveAppointment(candidate) ||
      isCandidateAlreadyDismissed(candidate) ||
      isCandidateAlreadyHired(candidate) ||
      isCandidateReadOnly(candidate) ||
      isCandidateHireInReview(candidate.computedStatus?.status)
    : true;
  const dismissActionDisabled = candidate
    ? isCandidateAlreadyDismissed(candidate) || isCandidateAlreadyHired(candidate) || isCandidateReadOnly(candidate)
    : true;

  const { isOpen: isUnDismissModalOpen, onOpen: onUnDismissModalOpen, onClose: onUnDismissModalClose } = useDisclosure();

  /* istanbul ignore next */
  const isCandidateEligibleToInteract = candidate?.seekerLookingForWork || candidate?.hired;
  const { checkPermission } = useUserPermission();

  const hasHireFormTemplate = !!selectedCandidate?.hireFormTemplateId;

  const isReadyToShowHireDetail = (status: string | undefined): boolean => {
    return !(status === 'requested' || status === 'inProgress');
  };

  const shouldShowUndismissBtn =
    candidate && isCandidateAlreadyDismissed(candidate) && isUndismissedeEnabled && !isCandidateBlacklisted(candidate);

  const shouldShowUnblockBtn =
    (isSuperAdmin || isAdmin) &&
    candidate &&
    isCandidateBlacklisted(candidate) &&
    !!seekerData &&
    !isBlacklistedBySeeker({
      excludedAccounts: seekerData?.excludedAccounts,
      accountId: candidate.account,
    });

  const isNewHireForm = isReadyToShowHireDetail(selectedCandidate?.hireDetailsStatus) && hasHireFormTemplate;

  const showCertnBackgroundCheckMenu = () => {
    return (
      isCertnFeatureEnabled && (
        <PermissionWrapper
          permissions={[EmployeePermissionsEnum.BACKGROUND_CHECK_REQUEST]}
          mode="disable"
          enableTooltip
          disableDisplayType="block"
        >
          <MenuItem
            data-testid="BackgroundCheckDropdownTestId"
            id="MeetMenuItem"
            minH="48px"
            _focus={{ bg: colors.blue['700'] }}
            disabled={
              !checkPermission({ permissions: [EmployeePermissionsEnum.BACKGROUND_CHECK_REQUEST] }) ||
              (!(certnStatus === 'dispute' || certnStatus === 'complete' || certnStatus === undefined) && isCertnEnabled) ||
              (!_isNil(positionScreeningOption) && !positionScreeningOption.enableScreeningOptions) ||
              isUserDeactivated ||
              isCurrentCandiateNeitherFollowedNorWatched
            }
            onClick={isCertnEnabled ? onBackgroundCheckModalOpen : onSubscribeForBackgroundCheckModalOpen}
            color={isCertnEnabled ? '#ffffff' : '#9FC5D9'}
          >
            <Tooltip
              label={
                !_isNil(positionScreeningOption) && !positionScreeningOption.enableScreeningOptions
                  ? t('certn:messageNotEnabledOnPositionLevel')
                  : ''
              }
              aria-label={
                !_isNil(positionScreeningOption) && !positionScreeningOption.enableScreeningOptions
                  ? t('certn:messageNotEnabledOnPositionLevel')
                  : ''
              }
              placement="top-start"
            >
              <Flex alignItems="center">
                <Box pr="12px">
                  <IoMdCheckboxOutline />
                </Box>
                <Box>
                  <Text>{t('certn:bgCheckLabel')}</Text>
                </Box>
              </Flex>
            </Tooltip>
          </MenuItem>
        </PermissionWrapper>
      )
    );
  };

  // istanbul ignore next
  const hireActionHandler = (status: CandidateStatus | undefined) => {
    let hireMenu;
    if (status === CandidateStatus.AppointmentRequested) {
      hireMenu = (
        <Fragment>
          <CustomMenuItem
            id="HireMenuItem"
            icon={<IoIosStar />}
            label={t('messaging:actions.hire.offerMade')}
            testId="AppointmentRequestedAction"
            handleClick={() =>
              candidate && selectedSeeker?.offeredOrHiredAccounts?.includes(candidate.account)
                ? onOpenWarning()
                : onHireModalOpen()
            }
            isBtnDisabled={
              candidate?.offerAcceptanceStatus?.offerAccepted || isUserDeactivated || isCurrentCandiateNeitherFollowedNorWatched
            }
          />
          {showCertnBackgroundCheckMenu()}
        </Fragment>
      );
    } else if (status === CandidateStatus.OfferMade) {
      hireMenu = (
        <Fragment>
          {showCertnBackgroundCheckMenu()}
          {!candidate?.offerAcceptanceStatus?.offerAccepted && (
            <CustomMenuItem
              id="HireMenuItem"
              icon={<IoIosStar />}
              label={t('messaging:actions.hire.offerMade')}
              testId="AppointmentRequestedAction"
              handleClick={() =>
                candidate && selectedSeeker?.offeredOrHiredAccounts?.includes(candidate.account)
                  ? onOpenWarning()
                  : onHireModalOpen()
              }
              isBtnDisabled={isUserDeactivated || isCurrentCandiateNeitherFollowedNorWatched}
            />
          )}

          <PermissionWrapper
            permissions={[EmployeePermissionsEnum.HR_REQUEST]}
            mode="disable"
            enableTooltip
            disableDisplayType="block"
          >
            <CustomMenuItem
              id="HireMenuItem"
              icon={<IoIosStar />}
              label={t('messaging:actions.hire.hireOrReject')}
              testId="OfferMadeAction"
              handleClick={onHireRejectModalOpen}
              isBtnDisabled={
                (Boolean(position?.hireFormTemplateId) &&
                  !checkPermission({ permissions: [EmployeePermissionsEnum.HR_REQUEST] })) ||
                isUserDeactivated ||
                isCurrentCandiateNeitherFollowedNorWatched
              }
            />
          </PermissionWrapper>
        </Fragment>
      );
    } else if (status === CandidateStatus.Hired) {
      hireMenu = (
        <Fragment>
          <CustomMenuItem
            id="HireMenuItem"
            icon={<IoIosStar />}
            label={t('messaging:actions.hire.unhire')}
            testId="UnHireAction"
            handleClick={onUnhireModalOpen}
            isBtnDisabled={isUserDeactivated}
          />
          {showCertnBackgroundCheckMenu()}
        </Fragment>
      );
    } else if (status === CandidateStatus.OfferRejected) {
      hireMenu = (
        <Fragment>
          {showCertnBackgroundCheckMenu()}
          {candidateReofferEnabled && (
            /* istanbul ignore next */
            <CustomMenuItem
              id="OfferRejectedItem"
              icon={<IoIosStar />}
              label={t('messaging:actions.hire.reoffer')}
              testId="OfferRejectedAction"
              handleClick={() =>
                candidate && selectedSeeker?.offeredOrHiredAccounts?.includes(candidate.account)
                  ? onOpenWarning()
                  : onHireModalOpen()
              }
              isBtnDisabled={isUserDeactivated || hireActionDisabled}
            />
          )}

          <CustomMenuItem
            id="HireMenuItem"
            icon={<IoIosStar />}
            label={t('messaging:actions.hire.hireOrReject')}
            testId="OfferRejectedAction"
            handleClick={onHireRejectModalOpen}
            isBtnDisabled={isUserDeactivated}
          />
        </Fragment>
      );
    } else if (candidate?.hireDetailsStatus === 'approved') {
      hireMenu = (
        // istanbul ignore next
        <Fragment>
          {isAutomaticHireDisabledBothInAccountAndPosition && (
            /* istanbul ignore next */
            <CustomMenuItem
              id="HireMenuItem"
              icon={<IoIosStar />}
              label={t('messaging:actions.hire.hireOrReject')}
              testId="HireRejectAction"
              handleClick={onOpenHireCandidate}
              isBtnDisabled={isUserDeactivated || isCurrentCandiateNeitherFollowedNorWatched}
            />
          )}
        </Fragment>
      );
    } else {
      hireMenu = (
        <Fragment>
          <CustomMenuItem
            id="OfferMadeItem"
            icon={<IoIosStar />}
            label={t('messaging:actions.hire.offerMade')}
            testId="OfferMadeDisabledAction"
            handleClick={() =>
              candidate && selectedSeeker?.offeredOrHiredAccounts?.includes(candidate.account)
                ? onOpenWarning()
                : onHireModalOpen()
            }
            isBtnDisabled={hireActionDisabled || candidate?.offerAcceptanceStatus?.offerAccepted || isUserDeactivated}
          />
          {showCertnBackgroundCheckMenu()}
        </Fragment>
      );
    }

    return hireMenu;
  };

  const getTolTipForAction = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    if (candidate && isCandidateBlacklisted(candidate)) {
      return '';
    }
    if (isUserDeactivated) {
      return t('messaging:actions.disabledActionLabelDeactivated');
    }
    if (isCurrentCandiateNeitherFollowedNorWatched) {
      return t('messaging:actions.disabledActionLabel');
    }
    if (!isCandidateEligibleToInteract) {
      return t('messaging:actions.disabledActionLabelNotLookingForWork');
    }
    return '';
  };

  // istanbul ignore next
  const isAdhocInterviewEnable = () => {
    return (
      adhocInterviewEnabled &&
      candidate?.computedStatus?.status !== CandidateStatus.Dismissed &&
      candidate?.computedStatus?.status !== CandidateStatus.Hired &&
      candidate?.computedStatus?.status !== CandidateStatus.HiredOnAnotherPosition &&
      candidate?.computedStatus?.status !== CandidateStatus.NotLookingForWork
    );
  };

  // istanbul ignore next
  const i9CheckHandler = () => {
    let i9Menu;
    if (workbrightEnabled && position?.i9Enabled) {
      const hireFormStatus =
        hireFormEnabled &&
        _includes(hireFormEnabledPositions, candidate?.newHireData ? candidate?.newHireData?.positionId : candidate?.position);

      const isDisabled =
        !checkPermission({ permissions: [EmployeePermissionsEnum.I9_REQUEST] }) ||
        (hireFormStatus ? candidate?.hireDetailsStatus !== 'completed' : !candidate?.offerAcceptanceStatus?.offerAccepted);
      i9Menu = (
        <Fragment>
          <CustomMenuItem
            id="I9-MenuItem"
            icon={<BsPersonCheckFill size={18} />}
            testId="I9-MenuItem"
            label={t('actions.i9Check.label')}
            handleClick={onI9CheckModalOpen}
            isBtnDisabled={isDisabled}
          />
        </Fragment>
      );
    }
    return i9Menu;
  };

  const renderActionButtons = () => {
    if (shouldShowUndismissBtn) {
      return (
        <Button
          css={menuButtonCSS}
          onClick={() => onUnDismissModalOpen()}
          data-testid="unDismissedButton"
          fontWeight="400"
          _hover={{ bg: colors.neutralGray['100'] }}
        >
          {' '}
          {t('messaging:actions.unDismissButton')}
        </Button>
      );
    }

    if (shouldShowUnblockBtn) {
      return (
        <Button
          css={menuButtonCSS}
          onClick={() => onUnblockModalOpen()}
          data-testid="unblockButton"
          fontWeight="400"
          _hover={{ bg: colors.neutralGray['100'] }}
        >
          {t('messaging:actions.unblock.unblockButton')}
        </Button>
      );
    }

    return (
      <Menu id="ActionsDropdownMenu" placement="bottom-end" closeOnSelect={false}>
        {({ isOpen }) => (
          <Fragment>
            <Tooltip hasArrow label={getTolTipForAction()} shouldWrapChildren placement="bottom-end" gutter={25}>
              {isUserDeactivated && candidate?.hired ? (
                /* istanbul ignore next */
                <CustomMenuItem
                  id="HireMenuItem"
                  icon={<IoIosStar />}
                  testId="UnHireAction"
                  label={t('messaging:actions.hire.unhire')}
                  handleClick={onUnhireModalOpen}
                  css={menuButtonCSS}
                  px={{ lg: 4, md: 2, sm: 2 }}
                  rounded="lg"
                />
              ) : (
                <MenuButton
                  _disabled={{
                    opacity: 0.5,
                    cursor: 'not-allowed',
                    boxShadow: 'none',
                  }}
                  css={menuButtonCSS}
                  className={isOpen ? 'is-opened' : ''}
                  px={{ lg: 4, md: 2, sm: 2 }}
                  py={2}
                  rounded="lg"
                  data-testid="DropDownActions"
                  disabled={isUserDeactivated || !isCandidateEligibleToInteract || isCurrentCandiateNeitherFollowedNorWatched}
                >
                  <Box display={{ lg: 'flex', md: 'none', sm: 'none' }} alignItems="center" placement="bottom-end">
                    {t('messaging:actions.label')}
                    <Box ml={2} marginRight="-6px">
                      {isOpen ? <IoIosArrowUp size={16} /> : <IoIosArrowDown size={16} />}
                    </Box>
                  </Box>
                  <Box display={{ lg: 'none', md: 'block' }}>
                    <IoMdMore size={22} />
                  </Box>
                </MenuButton>
              )}
            </Tooltip>
            <MenuList bg={colors.blue['500']} color={colors.white} css={menuListCSS}>
              <MenuItem
                closeOnSelect={false}
                id="MeetMenuItem"
                minH="48px"
                _focus={{ bg: colors.blue['700'] }}
                justifyContent="space-between"
                data-testid="interview-accordion-button"
                onClick={() => setIsInterviewMenuExpand(!isInterviewMenuExpand)}
              >
                <Flex alignItems="center">
                  <Box pr="12px">
                    <IoIosCalendar />
                  </Box>
                  {t('messaging:actions.meet.interviewLabel')}
                </Flex>
                <Box pl="12px">{!isInterviewMenuExpand ? <IoIosArrowForward size={16} /> : <IoIosArrowDown size={16} />}</Box>
              </MenuItem>
              {isInterviewMenuExpand && (
                <Box pl={6} pr={3}>
                  {isAdhocInterviewEnable() && candidate?.monetized && (
                    /* istanbul ignore next */
                    <CustomMenuItem
                      id="AdhocMenuItem"
                      icon={<IoMdAlarm />}
                      testId="AdhocMenuItem"
                      label={t('messaging:actions.adHoc.label')}
                      handleClick={onAdhocInterviewOpen}
                    />
                  )}

                  <CustomMenuItem
                    id="MeetMenuItem"
                    icon={<IoMdCalendar />}
                    testId="MeetMenuItem"
                    label={t('messaging:actions.meet.label')}
                    handleClick={onMeetModalOpen}
                    isBtnDisabled={meetActionDisabled || isUserDeactivated || isCurrentCandiateNeitherFollowedNorWatched}
                  />
                </Box>
              )}
              {hireActionHandler(candidate?.computedStatus?.status)}

              {candidate?.hireDetailsStatus === 'completed' && hireFormEnabled && isNewHireForm && isHrReviewUiEnabled && (
                <Box>
                  <MenuItem
                    closeOnSelect={false}
                    id="HireMenuItem"
                    minH="48px"
                    _focus={{ bg: colors.blue['700'] }}
                    justifyContent="space-between"
                    data-testid="hire-menu-accordion-button"
                    onClick={() => setIsHireMenuExpand(!isHireMenuExpand)}
                  >
                    <Flex alignItems="center">
                      <Box pr="12px">
                        <IoDocumentTextOutline />
                      </Box>
                      {t('messaging:actions.hire.hrFromBtn')}
                    </Flex>
                    <Box pl="12px">{!isHireMenuExpand ? <IoIosArrowForward size={16} /> : <IoIosArrowDown size={16} />}</Box>
                  </MenuItem>
                  {isHireMenuExpand && (
                    <Box pl={6} pr={3}>
                      <PermissionWrapper
                        permissions={[EmployeePermissionsEnum.HR_REQUEST]}
                        mode={PERMISSION_MODE.disable}
                        enableTooltip
                        disableDisplayType="block"
                      >
                        <CustomMenuItem
                          id="HRApproveMenuItem"
                          icon={<MdOutlineCheckCircle />}
                          testId="ApproveMenuItem"
                          label={t('messaging:actions.hire.approveHrFrom')}
                          handleClick={() => {
                            onHireDetailModalOpen();
                            setCurrentHireFormReviewStatus(HireFormReviewStatus.APPROVED);
                          }}
                        />
                      </PermissionWrapper>

                      <PermissionWrapper
                        permissions={[EmployeePermissionsEnum.HR_REQUEST]}
                        mode={PERMISSION_MODE.disable}
                        enableTooltip
                        disableDisplayType="block"
                      >
                        <CustomMenuItem
                          id="HRRejectMenuItem"
                          icon={<RiCloseCircleLine />}
                          testId="HRRejectMenuItem"
                          label={t('messaging:actions.hire.rejectHrFrom')}
                          handleClick={() => {
                            onHireDetailModalOpen();
                            setCurrentHireFormReviewStatus(HireFormReviewStatus.REJECTED);
                          }}
                        />
                      </PermissionWrapper>

                      <PermissionWrapper
                        permissions={[EmployeePermissionsEnum.HR_REQUEST]}
                        mode={PERMISSION_MODE.disable}
                        enableTooltip
                        disableDisplayType="block"
                      >
                        <CustomMenuItem
                          id="HRResubmitMenuItem"
                          icon={<HiOutlineRefresh />}
                          testId="HRResubmitMenuItem"
                          label={t('messaging:actions.hire.resubmitHrFrom')}
                          handleClick={() => {
                            onHireDetailModalOpen();
                            setCurrentHireFormReviewStatus(HireFormReviewStatus.NEEDS_ACTION);
                          }}
                        />
                      </PermissionWrapper>
                    </Box>
                  )}
                </Box>
              )}

              {i9CheckHandler()}

              <CustomMenuItem
                id="DismissMenuItem"
                icon={<IoMdRemoveCircleOutline />}
                testId="DismissMenuItem"
                label={t('messaging:actions.dismiss.label')}
                handleClick={onDismissModalOpen}
                isBtnDisabled={dismissActionDisabled}
              />
            </MenuList>
          </Fragment>
        )}
      </Menu>
    );
  };

  return (
    <Fragment>
      {isMessageAferHiringModalOpen && (
        <MessageAfterHiringModal isOpen={isMessageAferHiringModalOpen} onClose={onMessageAferHiringModalClose} />
      )}
      {isAdhocInterviewOpen && <AdHocInterviewModal isOpen={isAdhocInterviewOpen} onClose={onAdhocInterviewModalClose} />}
      {isUnhireModalOpen && (
        <UnhireConfirmationModal
          isOpen={isUnhireModalOpen}
          disabled={false}
          onClose={onUnhireModalClose}
          isMessagingView={isMessagingView}
        />
      )}
      {isHireRejectModalOpen && (
        <HireRejectConfirmationModal
          isOpen={isHireRejectModalOpen}
          warningMessage={warningMessage}
          messageModalOpen={onMessageAferHiringModalOpen}
          disabled={false}
          onClose={onHireRejectModalClose}
        />
      )}

      {isOpenHireCandidate && (
        /* istanbul ignore next */
        <HireRejectCandidateModal
          isOpen={isOpenHireCandidate}
          onClose={onCloseHireCandidate}
          warningMessage={warningMessage}
          disabled={false}
          messageModalOpen={onMessageAferHiringModalOpen}
          candidateIdFromProps=""
        />
      )}
      {isHireModalOpen && (
        <Box>
          {requisitionEnabled ? (
            /* istanbul ignore next */
            <HireWithRequisitionModal
              isOpen={isHireModalOpen}
              disabled={false}
              onClose={onHireModalClose}
              requisitionEnabled={requisitionEnabled}
              selectedRequisitionID={req}
            />
          ) : (
            <HireConfirmationModal
              positionSalaryDetails={positionScreeningOption?.proposedSalary}
              isOpen={isHireModalOpen}
              disabled={false}
              onClose={onHireModalClose}
              requisitionEnabled={requisitionEnabled}
            />
          )}
        </Box>
      )}
      {isMeetModalOpen && (
        <MeetConfirmationModal
          isOpen={isMeetModalOpen}
          disabled={isMessagingView ? meetActionDisabled : false}
          onClose={onConfirmModalClose}
          isMessagingView={isMessagingView}
        />
      )}

      {isI9CheckModalOpen && (
        /* istanbul ignore next */ <I9CheckModal isOpen={isI9CheckModalOpen} onClose={onI9CheckModalClose} />
      )}

      {isDismissModalOpen && (
        <DismissConfirmationModal
          isOpen={isDismissModalOpen}
          disabled={dismissActionDisabled}
          onClose={onDismissModalClose}
          isMessagingView={isMessagingView}
        />
      )}
      {isSubscribeForBackgroundCheckModalOpen && (
        /* istanbul ignore next */ <SubscribeForBackgroundCheckModal
          isOpen={isSubscribeForBackgroundCheckModalOpen}
          onClose={onSubscribeForBackgroundCheckModalClose}
        />
      )}
      {isBackgroundCheckModalOpen && (
        <BackgroundCheckModal isOpen={isBackgroundCheckModalOpen} onClose={onBackgroundCheckModalClose} />
      )}

      {renderActionButtons()}

      {isUnDismissModalOpen && (
        <UnDismissConfirmationModal
          isOpen={isUnDismissModalOpen}
          onClose={onUnDismissModalClose}
          isMessagingView={isMessagingView}
        />
      )}

      {isUnblockModalOpen && <UnblockConfirmModal isOpen={isUnblockModalOpen} onClose={onUnblockModalClose} />}

      {isOpenWarning && (
        <AlertDialog
          isOpen={isOpenWarning}
          leastDestructiveRef={cancelRef}
          onClose={onCloseWarning}
          isCentered
          size="5xl"
          scrollBehavior="inside"
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontWeight="bold" fontSize="22px" pb="0px">
                <Box>{t('messaging:offerMadewarning.title')}</Box>

                <Flex background="#FFFFF0" color="#B7791F" borderLeft="6px solid #FFB323" p="10px" alignItems="center" mt="10px">
                  <RiErrorWarningLine size="30px" color="#FFB323" />
                  <Text ml="10px" fontSize="16px">
                    {t('messaging:offerMadewarning.subtitle')}
                  </Text>
                </Flex>
                <Text fontWeight="900" fontSize="20px" color={colors.blue.default} mt="12px">
                  {t('messaging:offerMadewarning.offerHistory')}
                </Text>
              </AlertDialogHeader>

              <AlertDialogBody>
                <OfferMadePositionsView />
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button onClick={onCloseWarning} colorScheme="red">
                  {t('messaging:actions.meet.confirmationModal.cancelButton')}
                </Button>
                <Button
                  ref={cancelRef}
                  data-testid="onAcceptButton"
                  colorScheme="blue"
                  onClick={
                    /* istanbul ignore next */ () => {
                      onCloseWarning();
                      onHireModalOpen();
                    }
                  }
                  ml={3}
                >
                  {t('messaging:offerMadewarning.continueAnyWay')}
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      )}
    </Fragment>
  );
};
